<template>
  <main class="dashboard links">
    <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h2>Рейтинг</h2>


    </div>
    <div class="filters d-flex">
      <div class="item">
        <h5>Статус</h5>
        <div v-if="status">Идёт сбор оценок <span class="loader_text"></span></div>
        <div v-else-if="ready" class="ready btn btn-sm btn-outline-success disabled">Данные собраны</div>
        <div v-else>Сбор оценок не запущен</div>
        <a v-if="status" class="btn btn-sm btn-outline-secondary" disabled>Скачать последний файл</a>
        <a :href="link+'?ver='+Math.random()" target="_blank" v-else class="btn btn-sm btn-outline-dark">Скачать последний файл</a>
      </div>
      <div class="item">
        <h5>Загрузка</h5>
        <input class="form-control" ref="ratingFile" type="file" id="ratingFile">
        <button class="btn btn-sm btn-outline-success" @click="startParser">Загрузить и запустить сбор</button>
      </div>
    </div>


  </main>
</template>

<script>

import {RatingApi} from "@/api/rating";
import {state} from "@/socket";

export default {
  name: 'RatingPage',

  data() {
    return {
      status: true,
      ready: false,
      link: ""
    }
  },

  mounted: function () {
    this.getCurrentStatus()
  },
   computed: {
     rating_xlsx(value) {
      return state.rating_xlsx
    },
  },

  watch: {
    rating_xlsx(value) {
      this.status = false;
      this.ready = true;
      this.$notify(
            {
              type: "success",
              text: value.message
            }
        )
    },
  },
  methods: {
    startParser() {
      let formData = new FormData;
      this.ready = false;

      if (!this.$refs.ratingFile.files.length){
        this.$notify(
            {
              type: "error",
              text: "Выберите файл для загрузки"
            }
        )
      }
      else {
        formData.append("file", this.$refs.ratingFile.files[0])
        RatingApi.start_parse_xls_rating(formData).then(response => {
          this.$notify(response)
          setTimeout(()=>this.getCurrentStatus(), 2000)

        })
      }
    },
    getCurrentStatus() {
      const $this = this;

      RatingApi.get_xls_rating().then(response => {
        $this.status = response.rating_process
        $this.link = response.link
      })
    }

  }
}

</script>
<style scoped lang="scss">
.filters {
  gap: 50px!important;

  .item {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

.loader_text {
  width: 13px;
  aspect-ratio: 1;
  --c: no-repeat linear-gradient(#000 0 0);
  background: var(--c) 0% 50%,
  var(--c) 50% 50%,
  var(--c) 100% 50%;
  background-size: 20% 100%;
  animation: l1 1s infinite linear;
  display: inline-block;
}

@keyframes l1 {
  0% {
    background-size: 20% 100%, 20% 100%, 20% 100%
  }
  33% {
    background-size: 20% 10%, 20% 100%, 20% 100%
  }
  50% {
    background-size: 20% 100%, 20% 10%, 20% 100%
  }
  66% {
    background-size: 20% 100%, 20% 100%, 20% 10%
  }
  100% {
    background-size: 20% 100%, 20% 100%, 20% 100%
  }
}
</style>


